module.exports = __webpack_public_path__ + "img/banner-qys.a6a65613.jpg";